module.exports = __webpack_public_path__ + "img/schedules-not-updated-v2.269b64eb.svg";